import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _campaignGoal = { deadline: 'google.protobuf.Timestamp' };
var _createDonationCampaignRequest = {
    donationCampaign: '_donationCampaign',
};
var _createDonationCampaignResponse = {
    donationCampaign: '_donationCampaign',
};
var _deleteDonationCampaignRequest = {};
var _deleteDonationCampaignResponse = {};
var _donationCampaign = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    campaignGoal: '_campaignGoal',
};
var _getDonationCampaignMetricsRequest = {};
var _getDonationCampaignMetricsResponse = {};
var _getDonationCampaignRequest = {};
var _getDonationCampaignResponse = { donationCampaign: '_donationCampaign' };
var _getDonationCampaignStatisticsRequest = {};
var _getDonationCampaignStatisticsResponse = {};
var _queryDonationCampaignRequest = {};
var _queryDonationCampaignResponse = {
    donationCampaigns: '_donationCampaign',
};
var _updateDonationCampaignRequest = {
    mask: 'google.protobuf.FieldMask',
    donationCampaign: '_donationCampaign',
};
var _updateDonationCampaignResponse = {
    donationCampaign: '_donationCampaign',
};
function resolveWixDonationsCampaignV1DonationCampaignServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/_api/donations-campaign-service',
                destPath: '',
            },
            {
                srcPath: '/donations-campaign-service',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/donations-campaign-service',
                destPath: '',
            },
            {
                srcPath: '/_api/donations-campaign-service',
                destPath: '/api',
            },
        ],
        _: [
            {
                srcPath: '/donations-campaign-service',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/donations-campaign-service',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/donations-campaign-service',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/donations-campaign-service',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/donations-campaign-service',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/donations-campaign-service',
                destPath: '',
            },
        ],
        _base_domain_: [
            {
                srcPath: '/donations-campaign-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a new DonationCampaign */
export function createDonationCampaign(payload) {
    var _a = serializer(_createDonationCampaignRequest, { _campaignGoal: _campaignGoal, _donationCampaign: _donationCampaign }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createDonationCampaignResponse, {
        _campaignGoal: _campaignGoal,
        _donationCampaign: _donationCampaign,
    }).fromJSON;
    function __createDonationCampaign(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.donations.v1.donation_campaign',
            method: 'POST',
            methodFqn: 'wix.donations.campaign.v1.DonationCampaignService.CreateDonationCampaign',
            url: resolveWixDonationsCampaignV1DonationCampaignServiceUrl({
                protoPath: '/v1/donation-campaigns',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createDonationCampaign.fromReq = fromReq;
    __createDonationCampaign.__isAmbassador = true;
    return __createDonationCampaign;
}
/** Get a DonationCampaign by id */
export function getDonationCampaign(payload) {
    var _a = serializer(_getDonationCampaignRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getDonationCampaignResponse, {
        _campaignGoal: _campaignGoal,
        _donationCampaign: _donationCampaign,
    }).fromJSON;
    function __getDonationCampaign(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.donations.v1.donation_campaign',
            method: 'GET',
            methodFqn: 'wix.donations.campaign.v1.DonationCampaignService.GetDonationCampaign',
            url: resolveWixDonationsCampaignV1DonationCampaignServiceUrl({
                protoPath: '/v1/donation-campaigns/{donationCampaignId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getDonationCampaign.fromReq = fromReq;
    __getDonationCampaign.__isAmbassador = true;
    return __getDonationCampaign;
}
/**
 * Update a DonationCampaign, supports partial update
 * Pass the latest `revision` for a successful update
 */
export function updateDonationCampaign(payload) {
    var _a = serializer(_updateDonationCampaignRequest, { _campaignGoal: _campaignGoal, _donationCampaign: _donationCampaign }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateDonationCampaignResponse, {
        _campaignGoal: _campaignGoal,
        _donationCampaign: _donationCampaign,
    }).fromJSON;
    function __updateDonationCampaign(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.donations.v1.donation_campaign',
            method: 'PATCH',
            methodFqn: 'wix.donations.campaign.v1.DonationCampaignService.UpdateDonationCampaign',
            url: resolveWixDonationsCampaignV1DonationCampaignServiceUrl({
                protoPath: '/v1/donation-campaigns/{donationCampaign.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateDonationCampaign.fromReq = fromReq;
    __updateDonationCampaign.__isAmbassador = true;
    return __updateDonationCampaign;
}
/** Delete a DonationCampaign */
export function deleteDonationCampaign(payload) {
    var _a = serializer(_deleteDonationCampaignRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteDonationCampaignResponse, {}).fromJSON;
    function __deleteDonationCampaign(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.donations.v1.donation_campaign',
            method: 'DELETE',
            methodFqn: 'wix.donations.campaign.v1.DonationCampaignService.DeleteDonationCampaign',
            url: resolveWixDonationsCampaignV1DonationCampaignServiceUrl({
                protoPath: '/v1/donation-campaigns/{donationCampaignId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteDonationCampaign.fromReq = fromReq;
    __deleteDonationCampaign.__isAmbassador = true;
    return __deleteDonationCampaign;
}
/** Query DonationCampaigns using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) */
export function queryDonationCampaign(payload) {
    var _a = serializer(_queryDonationCampaignRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryDonationCampaignResponse, {
        _campaignGoal: _campaignGoal,
        _donationCampaign: _donationCampaign,
    }).fromJSON;
    function __queryDonationCampaign(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.donations.v1.donation_campaign',
            method: 'POST',
            methodFqn: 'wix.donations.campaign.v1.DonationCampaignService.QueryDonationCampaign',
            url: resolveWixDonationsCampaignV1DonationCampaignServiceUrl({
                protoPath: '/v1/donation-campaigns/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryDonationCampaign.fromReq = fromReq;
    __queryDonationCampaign.__isAmbassador = true;
    return __queryDonationCampaign;
}
/**
 * Get metrics for a specific Donation Campaign.
 * This endpoint is deprecated. Please use `GetDonationCampaignMetrics` instead.
 * @deprecated It has been replaced with GetDonationCampaignMetrics(), and will be removed on 2025-07-01.
 */
export function getDonationCampaignStatistics(payload) {
    var _a = serializer(_getDonationCampaignStatisticsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getDonationCampaignStatisticsResponse, {}).fromJSON;
    function __getDonationCampaignStatistics(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.donations.v1.donation_campaign',
            method: 'GET',
            methodFqn: 'wix.donations.campaign.v1.DonationCampaignService.GetDonationCampaignStatistics',
            url: resolveWixDonationsCampaignV1DonationCampaignServiceUrl({
                protoPath: '/v1/donation-campaigns/{donationCampaignId}/statistics',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getDonationCampaignStatistics.fromReq = fromReq;
    __getDonationCampaignStatistics.__isAmbassador = true;
    return __getDonationCampaignStatistics;
}
/**
 * Get metrics for a specific Donation Campaign.
 * Setting a campaign goal is a prerequisite for this operation.
 *
 * Returns: the number of donations and the total amount collected for the campaign so far.
 */
export function getDonationCampaignMetrics(payload) {
    var _a = serializer(_getDonationCampaignMetricsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getDonationCampaignMetricsResponse, {}).fromJSON;
    function __getDonationCampaignMetrics(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.donations.v1.donation_campaign',
            method: 'GET',
            methodFqn: 'wix.donations.campaign.v1.DonationCampaignService.GetDonationCampaignMetrics',
            url: resolveWixDonationsCampaignV1DonationCampaignServiceUrl({
                protoPath: '/v1/donation-campaigns/{donationCampaignId}/metrics',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getDonationCampaignMetrics.fromReq = fromReq;
    __getDonationCampaignMetrics.__isAmbassador = true;
    return __getDonationCampaignMetrics;
}
//# sourceMappingURL=http.impl.js.map